// Kept free of imports and side effects so tests can import these without pulling in
// checkout-globals, which builds `globalThis.Checkout` at module load.
export const PaypalStates = {
  IDLE: 'idle',
  INITIALIZED: 'initialized',
  ERROR: 'error',
  ADDING_PAYMENT_METHOD: 'adding-payment-method',
  PAYMENT_METHOD_APPROVED: 'payment-method-approved',
}

export const ErrorTypes = {
  REBILLY_ERROR: 'rebilly-error',
  SERVER_ERROR: 'server-error',
  UNHANDLED_SERVER_RESPONSE: 'unhandled-server-response',
  THREEDS_DECLINED_ERROR: '3ds-declined-error',
  THREEDS_DECLINED_CUSTOM_ERROR: '3ds-declined-custom-error',
  PAYPAL_DECLINED_ERROR: 'paypal-declined-error',
  PAYPAL_CUSTOM_ERROR: 'paypal-custom-error',
}
